// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "module." + {"612":"scroll-lock","979":"swiper"}[chunkId] + ".js?v=" + {"612":"1fee2169c838425ffbdd","979":"0091196bb42f9353fadc"}[chunkId] + "";
};